import { z } from 'zod'
import { Name } from '../../_kernel/Name'
import { Slug } from '../../_kernel/Slug'
import { PropertyFilter } from './PropertyFilter'

export const BOARD_TYPES = [
  'breakfast',
  'all-inclusive',
  'half-board',
  'full-board',
  'room-only',
  'self-catering',
  'dinner',
  'lunch',
  'full-kitchen',
  'buffet',
] as const

export type BoardType = (typeof BOARD_TYPES)[number]

export const BoardValidation = z.object({
  name: z.instanceof(Name, { message: '[Board] name is required' }),
  slug: z.instanceof(Slug, { message: '[Board] slug is required' }),
})

export class Board extends PropertyFilter {
  static create({ name, slug }: z.infer<typeof BoardValidation>) {
    BoardValidation.parse({ name, slug })
    return new Board(name, slug)
  }
}
